<template>
  <div>
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      :searchDesc="searchDesc"
      @searchSubmit="searchSubmit"
      @refresh-change="getlist"
      @refreshBtn="refreshBtn"
    ></zx-table>
    <div class="from">
      <ele-form-dialog
        v-model="formData"
        :formDesc="formDesc"
        :request-fn="handleSubmit"
        :rules="rules"
        labelPosition="left"
        :form-attrs="{ size: 'small' }"
        :dialogAttrs="{
          center: false,
          'destroy-on-close': true,
          'custom-class': 'formD'
        }"
        :visible.sync="dialogFormVisible"
        @request-success="handleSuccess"
        :title="'提现审核'"
      >
      </ele-form-dialog>
      <ele-form-dialog
        v-model="editData"
        :formDesc="editDesc"
        :request-fn="editHandleSubmit"
        labelPosition="left"
        :form-attrs="{ size: 'small' }"
        :dialogAttrs="{
          center: false,
          'destroy-on-close': true,
          'custom-class': 'formD'
        }"
        :visible.sync="editDialogFormVisible"
        @request-success="editHandleSuccess"
        :title="'编辑提现'"
      >
      </ele-form-dialog>
    </div>
    <!-- <el-dialog title="提现审核" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <span>提现审核</span>
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入提现审核备注"
        v-model="refundPostData.refuse_reason"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="refundSubmit">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import * as order from "@/api/product/order.js";
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      formData: {},
      formDesc: {
        sn: {
          type: "text",
          label: "订单号"
        },
        member: {
          type: "text",
          label: "发起人"
        },
        money: {
          type: "text",
          label: "提现金额"
        },
        create_time: {
          type: "text",
          label: "提现发起时间"
        },
        remark: {
          type: "text",
          label: "提现备注"
        },
        status: {
          type: "radio",
          label: "处理类型",
          options: [
            { text: "同意", value: 1 },
            { text: "驳回", value: -1 }
          ]
        },
        pay_type: {
          type: "select",
          label: "提现方式",
          options: [
            { text: "现金", value: 3 },
            { text: "微信红包", value: 4 }
          ],
          vif(data) {
            return data.status === 1;
          }
        },
        refuse_reason: {
          type: "input",
          label: "提现审核备注",
          vif(data) {
            return data.status === 1;
          }
        }
      },
      editData: {},
      editDesc: {
        member: {
          type: "text",
          label: "发起人"
        },
        money: {
          type: "input",
          label: "提现金额"
        },
        refuse_reason: {
          type: "input",
          label: "操作备注"
        }
      },
      rules: {},
      dialogFormVisible: false,
      editDialogFormVisible: false,
      refundPostData: {
        rebate_id: "",
        status: 1,
        refuse_reason: ""
      },

      searchDesc: {
        trade_no: {
          label: "订单号",
          type: "input"
        },
        date: {
          field: "date",
          label: "时间范围",
          type: "daterange",
          attrs: {
            valueFormat: "yyyy-MM-dd",
            pickerOptions: {
              shortcuts: [
                {
                  text: "最近一周",
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit("pick", [start, end]);
                  }
                },
                {
                  text: "最近一个月",
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit("pick", [start, end]);
                  }
                },
                {
                  text: "最近三个月",
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit("pick", [start, end]);
                  }
                }
              ]
            }
          }
        }
      },
      searchData: {},
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 25,
        pageSizes: [15, 25, 30, 40, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "计划",
        // 多选 默认:false;
        selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: true,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: false,
        // 编辑 默认:true;
        editBtn: false,
        // 删除  默认:true;
        delBtn: false,
        // 折叠筐 默认:false;
        expand: false,
        expandStyle: "width:50%;display:inline-flex;",
        column: [
          {
            prop: "sn",
            // 列名
            label: "订单号",
            hide: true
          },
          {
            prop: "member",
            // 列名
            label: "提现人",
            hide: true
          },
          {
            prop: "money",
            // 列名
            label: "提现金额",
            hide: true
          },
          {
            prop: "status",
            // 列名
            label: "状态",
            hide: true,
            show: "tag",
            tagtype: [
              {
                text: " 已作废",
                type: "danger",
                value: -1
              },
              {
                text: "待审核",
                type: "warning",
                value: 0
              },
              {
                text: "发放中",
                type: "success",
                value: 1
              },
              {
                text: "提现成功",
                type: "info",
                value: 2
              },
              {
                text: "过期待领取",
                type: "warning",
                value: 3
              }
            ]
          },
          {
            prop: "remark",
            // 列名
            label: "提现备注",
            hide: true
          },
          {
            prop: "create_time",
            // 列名
            label: "创建时间",
            hide: true
          },
          {
            prop: "update_time",
            // 列名
            label: "更新时间",
            hide: true
          }
        ],
        btnList: [
          {
            name: "提现审核",
            size: "mini",
            type: "text",
            click: (id, row, index) => {
              this.dialogFormVisible = true;
              this.formData = row;
            }
          },
          {
            name: "编辑",
            size: "mini",
            type: "text",
            click: (id, row, index) => {
              this.editDialogFormVisible = true;
              this.editData = row;
            }
          },
          {
            name: "单号重置",
            size: "mini",
            type: "text",
            click: (id, row, index) => {
              this.restSn(row);
            }
          }
        ]
      },
      tableData: []
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    //  提现提交
    handleSubmit(data) {
      order.editWithdraw
        .r({
          id: data.id,
          status: data.status,
          refuse_reason: data.refuse_reason,
          pay_type: data.pay_type
        })
        .then(res => {
          this.dialogFormVisible = false;
          this.getlist();
          this.$message.success("审核提交成功");
        });
    },
    handleSuccess() {},
    editHandleSubmit(data) {
      console.log(data);
      if (data.moeny > 499) {
        this.$message.success("超过单笔红包最大金额~");
        return false;
      }
      order.upWithdraw
        .r({
          id: data.id,
          money: data.money,
          refuse_reason: data.refuse_reason
        })
        .then(res => {
          this.editDialogFormVisible = false;
          this.getlist();
          this.$message.success("更新成功");
        });
    },
    editHandleSuccess() {},
    // 刷新
    refreshBtn(e) {
      this.getlist();
    },
    // 搜索提交
    searchSubmit(e) {
      this.searchData = e;
      if (e.date) {
        let date = {
          start_time: e.date[0],
          end_time: e.date[1]
        };
        delete e.date;
        this.searchData = {
          ...e,
          ...date
        };
      }
      if (e) {
        this.page.currentPage = 1;
      }
      this.getlist();
    },
    getlist(e) {
      let that = this;
      let param;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }
      // param["status"] = 0;
      order.getOrderRebate.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
      });
    },
    restSn(row) {
      order.restWithdraw
        .r({
          id: row.id
        })
        .then(res => {
          this.getlist();
          this.$message.success("操作成功");
        });
    }
  }
};
</script>
<style lang="scss" scoped></style>
